<header>
  <h1>{{ "__UI_KIT_UI_KIT_PAGE__" | translate }}</h1>
</header>
<main>
  <section class="btn-section">
    <h2>{{ "__UI_KIT_BUTTONS__" | translate }}</h2>
    <div class="btn-wrap">
      <button class="btn btn-primary">{{ "__UI_KIT_EXPORT_CALLS__" | translate }}</button>
    </div>
  </section>
  <section class="btn-section">
    <h2>{{ "__UI_KIT_TOGGLE__" | translate }}</h2>
    <div class="btn-wrap">
      <ion-toggle
          class="black-toggle"
          [attr.data-label-on]="'__ION_TOGGLE_YES__' | translate"
          [attr.data-label-off]="'__ION_TOGGLE_NO__' | translate"
          [checked]="groupByAgents"
          (ionChange)="groupByAgents = !groupByAgents"
          mode="ios"
      ></ion-toggle>
    </div>
  </section>
</main>
